import SvgIcon from '@/components/SvgIcon.vue';
import { useStore } from '@/store';
export default {
  components: {
    SvgIcon
  },
  created() {
    if (this.$route.query && this.$route.query.isSwitchAccount === '1') {
      this.againLogin();
    }
  },
  methods: {
    againLogin() {
      sessionStorage.removeItem('userInfo');
      // 退出后会话已失效，需走 ssoLogin 重新提交回跳地址（联调模式），否则登录后回跳到后端默认地址
      useStore().ssoLogin();
    }
  }
};